import { getCountries, getCountryCallingCode, type CountryCode } from 'libphonenumber-js/max';
import { buildCountryFlagEmoji } from './flagEmoji';

export interface PhoneCountryOption {
  value: CountryCode;
  label: string;
  flagEmoji: string;
  countryName: string;
  dialCodeText: string;
}

export function resolveCountryDisplayName(countryCode: CountryCode, language: string): string {
  const displayNames = new Intl.DisplayNames([language], { type: 'region' });
  const resolvedName = displayNames.of(countryCode);
  return resolvedName === undefined ? countryCode : resolvedName;
}

export function buildPhoneCountryOptions(language: string): PhoneCountryOption[] {
  return getCountries()
    .map(function toOption(countryCode) {
      const flagEmoji = buildCountryFlagEmoji(countryCode);
      const countryName = resolveCountryDisplayName(countryCode, language);
      const dialCodeText = '+' + getCountryCallingCode(countryCode);
      return {
        value: countryCode,
        label: flagEmoji + ' ' + countryName + ' ' + dialCodeText,
        flagEmoji,
        countryName,
        dialCodeText,
      };
    })
    .sort(function byCountryName(firstOption, secondOption) {
      return firstOption.countryName.localeCompare(secondOption.countryName);
    });
}
